import { tabbable } from "tabbable";

export function autoAdvance(el: HTMLElement) {
  const field = el.closest("[data-field-id]");
  const next = field?.nextElementSibling?.querySelector(
    "input, textarea, button",
  ) as HTMLElement | null;
  if (next) {
    setTimeout(() => {
      next.focus();
    }, 100);
  }
}

export function focusNextTabbable(el: HTMLElement) {
  const container = el.closest(".unified-editor-content");
  if (!container) {
    return;
  }
  const tabbables = tabbable(container) as HTMLElement[];
  const idx = tabbables.indexOf(el);
  const nextEl = tabbables[idx + 1];
  if (idx !== -1 && nextEl) {
    nextEl.focus();
  }
}
